<script setup lang="ts">
import { ref } from 'vue'

import { getClasses } from '~/js/composables/classes'

interface Props {
    theme?: string | null,
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    theme: null,
    utilities: ''
})

const classes = ref({
    _default: 'place-self-start inline-flex',
    border: 'border rounded-lg border-neutral-700 dark:border-white',
    font: 'font-primary whitespace-nowrap',
    size: 'w-fit',
    spacing: 'px-4 py-1',
    text: 'text-neutral-700 dark:text-white text-sm',
})
</script>

<template>
    <span 
        :class="[getClasses(classes), utilities]" 
        :data-theme="theme"
    >
        <slot></slot>
    </span>
</template>